import { useRef } from "react";
import { ConsultaPadrao } from "../../../../components/ConsultaPadrao";
import { model_categoria } from "../../../../models";
import { CategoriaExercicio } from "./CategoriaExercicio";
import { FaPersonRunning } from "react-icons/fa6";

export const Categoria = () => {
    const refExercicio = useRef<any>(null);

    const columns = [
        { field: 'catdescricao', header: 'Descrição' },
        { field: 'catativo', header: 'Ativo' },
        { field: 'functions', style: { minWidth: '7rem', width: '7rem' } }
    ];

    function functions(row: any) {
        return ([
            {
                label: 'Exercícios',
                click: () => refExercicio.current.openModal(row),
                icon: <FaPersonRunning size={24} />,
                color: '#0589a0'
            }
        ])
    }

    return (
        <>
            <ConsultaPadrao model={model_categoria} columns={columns} functions={functions} />
            <CategoriaExercicio ref={refExercicio} />
        </>
    )
}